import Address from '../user/address';
import Utms from '../utm/utms';
import CheckoutAdditionalData from './checkout-additional-data';
import CheckoutPayment from './checkout-payment';

export default class CheckoutBudget {
  public budgetHash?: string;
  public payment?: CheckoutPayment;
  public addressAdditionalData?: CheckoutAdditionalData;
  public utms?: Utms;

  constructor(
    budgetHash: string,
    payment: CheckoutPayment,
    address: Address | null,
    utms: Utms
  ) {
    this.budgetHash = budgetHash;
    this.payment = payment;
    this.utms = utms;

    if (address) {
      this.addressAdditionalData = new CheckoutAdditionalData(address);
    }
  }
}
